export interface BrandConfig {
  name: string;
  logo?: string;
  colors: {
    primary: string;
    background: string;
    buttonHover: string;
    buttonGradient: string;
    statusBorder: string;
    statusBackground: string;
    timelineDot: string;
    timelineGradient: string;
    cardBackground: string;
  };
  text: {
    title: string;
    placeholder: string;
    trackButton: string;
    trackingButton: string;
    clearButton: string;
    statusLabel: string;
    historyTitle: string;
    errorEnterNumber: string;
    errorTracking: string;
    errorConnection: string;
    pendingTitle: string;
    pendingDescription: string;
    pendingReasons: string[];
    pendingTryAgain: string;
    noResultsMessage: string;
  };
}

export const brandingConfig: Record<string, BrandConfig> = {
  default: {
    name: 'Default',
    colors: {
      primary: '#000000',
      background: '#FFFFFF',
      buttonHover: '#000000',
      buttonGradient: 'linear-gradient(135deg, #000000 0%, #333333 100%)',
      statusBorder: '#333333',
      statusBackground: '#f5f5f5',
      timelineDot: '#333333',
      timelineGradient: 'linear-gradient(180deg, #333333 0%, #666666 100%)',
      cardBackground: '#FFFFFF',
    },
    text: {
      title: '🚚 מעקב חבילות',
      placeholder: 'הזינו מספר מעקב',
      trackButton: '🔍 עקוב',
      trackingButton: '⏳ מחפש...',
      clearButton: 'נקה',
      statusLabel: 'סטטוס:',
      historyTitle: '📋 היסטוריית מעקב',
      errorEnterNumber: 'נא להזין מספר מעקב',
      errorTracking: 'שגיאה במעקב אחר החבילה',
      errorConnection: 'שגיאה בהתחברות לשרת',
      pendingTitle: '⏳ מידע על המעקב לא זמין כרגע',
      pendingDescription: 'מספר המעקב נרשם במערכת, אך המידע עדיין לא זמין.',
      pendingReasons: [
        'המתינו 5-30 דקות עד שהמערכת תשלוף את המידע מהחברה המשלחת',
        'ייתכן שהחבילה חדשה מאוד ועדיין לא נסרקה',
        'ייתכן שמספר המעקב אינו תקין',
      ],
      pendingTryAgain: 'נסו לעקוב שוב בעוד מספר דקות 🔄',
      noResultsMessage: 'לא נמצא מידע על מספר המעקב. אנא בדקו את המספר ונסו שוב.',
    },
  },
};

export const getBrandConfig = (ref: string | null): BrandConfig => {
  if (ref && brandingConfig[ref]) {
    return brandingConfig[ref];
  }
  return brandingConfig.default;
};




